import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AuthEventRepo, AuthEventType } from '../../../../enums/event/event.enum';
import { ModalView } from '../../../../models/event-data.model';
import { EventTrackingService } from '../../../../services/event-tracking.service';
import { IconCloseComponent } from '../../../shared/components/icon-close/icon-close.component';
import { LoanAccountType } from '../../models/accounts.model';

interface ModalData {
  productType: LoanAccountType;
  last4DigitsExternalAccountNumber: string;
}

@Component({
  selector: 'app-account-closed-modal',
  templateUrl: './account-closed-modal.component.html',
  styleUrls: ['./account-closed-modal.component.scss'],
  imports: [CommonModule, MatDialogModule, IconCloseComponent],
})
export class AccountClosedModalComponent implements OnInit {
  productType: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalData,
    private readonly eventTrackingService: EventTrackingService
  ) {}

  ngOnInit(): void {
    this.productType = this.getProductType(this.data.productType);
    const pageNameArr = location.pathname.split('/');
    const pageName = pageNameArr[pageNameArr.length - 1];

    this.eventTrackingService.trackEvent<ModalView>(AuthEventType.MODAL_VIEW, {
      siteSection: 'hub',
      cswPageName: pageName,
      product: 'PERSONAL_LOAN',
      customerPortalDisplayType: 'informational',
      customerPortalDisplayText: 'Account closed',
      eventRepo: AuthEventRepo.CustomerPortal,
    });
  }

  getProductType(productType: string) {
    if (!productType?.length || productType.length === 0) {
      return 'Personal loan';
    }
    return productType.charAt(0) + productType.slice(1).toLowerCase();
  }
}
